import { GetApiResponseByUrl } from '@crossbeam/openapi';

export type TimelineEvent =
  GetApiResponseByUrl<'/v0.1/activity-timeline/{source_id}/{master_id}'>['items'][0];

// Bridge for the only report event missing from the OpenAPI spec.
// Delete once `report_overlap_visible` is added to the spec.
export type ReportOverlapVisibleData = {
  report_id: string;
  report_name: string | null;
  action_organization_uuid: string;
};

export type ReportOverlapVisibleEvent = {
  organization_uuid: string;
  master_id: string;
  partner_organization_uuid: string | null;
  triggered_at: string;
  updated_at: string;
  uuid: string;
  source_id: number;
  created_at: string;
  trigger_event:
    | 'own_population_updated'
    | 'partner_population_updated'
    | 'own_data_shared'
    | 'partner_data_shared'
    | 'own_sync_feed'
    | 'partner_sync_feed'
    | 'partnership_created'
    | null;
  activity_source: 'crossbeam-core';
  type: 'report_overlap_visible';
  data: ReportOverlapVisibleData;
};

export function getReportOverlapVisibleData(
  activity: TimelineEvent,
): ReportOverlapVisibleData | null {
  if ((activity.type as string) !== 'report_overlap_visible') return null;
  return activity.data as unknown as ReportOverlapVisibleData;
}
